import { IPermissions } from 'common/permissions.types';
import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

export default function usePermissions(permissions?: any) {
  const getPermissions = () => {
    return localStorageUtil.get<IPermissions>(ELocalStorageKeys.PERMISSIONS);
  };

  const setPermissions = () => {
    const projects = localStorageUtil.get(
      ELocalStorageKeys.USER_DETAILS
    ).projects;
    if (projects) {
      const returnedProjects: any = {};
      projects.forEach((p: any) => {
        returnedProjects[p.publisherId] = {};
        p.permissions.forEach((permission: any) => {
          const splittedPermission = permission.split(':');
          const permissionValue = splittedPermission[1] + (splittedPermission[2] ? `:${splittedPermission[2]}` : '');
          if (returnedProjects[p.publisherId][splittedPermission[0]]) {
            returnedProjects[p.publisherId][splittedPermission[0]].push(
              permissionValue
            );
          } else {
            returnedProjects[p.publisherId][splittedPermission[0]] = [
              permissionValue
            ];
          }
        });
      });

      localStorageUtil.set(ELocalStorageKeys.PERMISSIONS, returnedProjects);
    }
  };

  return {
    getPermissions,
    setPermissions
  };
}
